import { LoaderSectionIDsEnum } from './../../../models/enums/General/LoaderSectionIDsEnum';
import { LoadingService } from './../../../services/loading.service';
import { SearchService } from 'src/app/services/search.service';
import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ReservationSettingModel } from 'src/app/models/Booking/ReservationSettingModel';

@Component({
  selector: 'home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.css']
})
export class HomePageComponent implements OnInit,AfterViewInit {
  reservationSettingModel: ReservationSettingModel;
  easyRentSection=true;
  gracePeriodInHours: number;
  constructor(private searchService:SearchService,private loadingService:LoadingService) { }

  ngAfterViewInit(): void {
    this.loadingService.hideViewLoader(LoaderSectionIDsEnum.HomePageComponent)
  }

  ngOnInit(): void {
    this.loadingService.showViewLoader(LoaderSectionIDsEnum.HomePageComponent)
    this.searchService.reservationSettings().subscribe(res =>{
      this.reservationSettingModel=res;

      this.searchService.updateReservationSettingModel(res);
      if(res!=null&&res.bookingGracePeriodSettings!=null){
        this.gracePeriodInHours=res.bookingGracePeriodSettings.bookingGracePeriodInHours;
      }
      if(res.eazyRentSettings!=null&&res.eazyRentSettings.enableEazyrent){
        this.easyRentSection=true;
      }
      else{
        this.easyRentSection=false;
      }
    })
  }


}
